<template>
    <v-container class="p-0" :style="maxWidth > 0 ? `max-width: ${maxWidth}px;` : ''">
        <div class="d-flex flex-column" :class="{ 'container-media': flagDiag }">
            <div
                v-for="(item, key) in files"
                :key="'J'+key"
                :class="{
                    'border-image': flagDiagImage
                }"
            >
                <div class="d-flex" v-if="flagDiag && flagNameAndBtn">
                    <p v-if="flagButtonDel" class="mb-3">{{ item.fileName }}</p>

                    <span v-if="flagButtonDel && !getFlagReadonly" @click.prevent="deleteFiles(item, key, files)">
                        <v-icon class="i-delete mb-3" color="error">mdi-delete</v-icon>
                    </span>
                </div>
                <v-img
                    class="media-custom"
                    :class="{ 'mb-6': flagDiag && key !== files.length-1 }"
                    v-if="(item.file && item.file.fileType == 2) || item.fileType == 2"
                    :src="`${apiFiles}${item.file && item.file.fileUrl || calculateUrl(item.filePath)}`"
                    contain
                    @click="clickPhoto(key, `${apiFiles}${(item.file && item.file.fileUrl) || calculateUrl(item.filePath)}`)"
                    :max-width="flagDiag ? 400 : null"
                />

                <audio
                    :class="{ 'mb-6': key !== files.length-1 }"
                    v-if="(item.file && item.file.fileType == 3) || item.fileType == 3"
                    controls
                    style="display: initial; width:100%"
                >
                    <source :src="`${apiFiles}${(item.file && item.file.fileUrl) || calculateUrl(item.filePath)}`" type="audio/mpeg" />
                    <p>
                        Ваш браузер не поддерживает HTML5 аудио. Вот взамен
                        <a :href="`${apiFiles}${(item.file && item.file.fileUrl) || calculateUrl(item.filePath)}`">ссылка на аудио</a>
                    </p>
                </audio>

                <video
                    v-if="(item.file && item.file.fileType == 4) || item.fileType == 4"
                    :class="{ 'mb-6': key !== files.length-1 }"
                    width="100%"
                    controls
                    class="media-custom"
                    poster="@/assets/poster.png"
                >
                    <source :src="`${apiFiles}${(item.file && item.file.fileUrl) || calculateUrl(item.filePath)}`" type="video/mp4">
                </video>
            </div>
        </div>

        <vue-easy-lightbox moveDisabled :visible="visible" :imgs="srcImg" :index="index" @hide="closetViewPhoto('visible')" />
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    props: {
        files: { type: Array, required: true },
        flagDiag: { type: Boolean, default: () => false },
        flagButtonDel: { type: Boolean, default: () => true },
        flagDiagImage: { type: Boolean, default: () => false },
        flagNameAndBtn: { type: Boolean, default: () => false },
        fileType: { type: Number, default: () => 0 },
        maxWidth: Number
    },
    data: () => ({
        visible: false,
        srcImg: [],
        index: null
    }),
    computed: {
        ...mapGetters({
            apiFiles: 'apiImg',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        })
    },
    methods: {
        ...mapActions({
            deleteFile: 'createDiagnosticTest/deleteFile'
        }),
        clickPhoto(e, url) {
            this.srcImg = [];
            this.srcImg.push({src: url});
            this.visible = true
            this.index = e
        },
        closetViewPhoto(name) {
            this[name] = false
			this.index = null
        },
        calculateUrl(url) {
            return `/${url.split('\\')[4]}/${url.split('\\')[5]}`
        },
        deleteFiles(item, key, files) {
            if(confirm('Вы уверены, что хотите удалить файл ?')) {
                // /DiaTest/DeleteMediaFile
                this.deleteFile({ item, key })
                    .then(() => {
                        files.splice(key, 1);
                    })
            }
        }
    }
}
</script>

<style scoped>
.container-media {
    max-height: 600px;
    overflow: auto;
}

.border-image {
    border: 1px solid #CACDD3;
    border-radius: 12px;
    padding: 10px;
    margin-right: 5px;
}

.container .flex-column div ~ div {
    margin-top: 6px;
}

.i-delete {
    cursor: pointer;
}

.media-custom {
    height: 300px;
    cursor: pointer;
}

@media screen and (max-width: 1400px) {
    .media-custom {
        height: 150px;
    }
}
</style>
